import React from 'react';
import { useTranslation } from 'react-i18next';
import { PasswordIcon, ProtectionIcon, ConsentIcon } from '..';
import * as S from './styled';

export const TrustLabels = ({ mt = 16, threeLabels = false }) => {
  const { t } = useTranslation();

  if (threeLabels) {
    return (
      <S.LabelsWrapper $mt={mt} $isThreeLabels={true}>
        <S.TrustItem>
          <ProtectionIcon />
          {t('confident')}
        </S.TrustItem>
        <S.TrustItem>
          <PasswordIcon />
          {t('secure_ssl')}
        </S.TrustItem>
        <S.TrustItem>
          <ConsentIcon />
          {t('consent_base')}
        </S.TrustItem>
      </S.LabelsWrapper>
    );
  }

  return (
    <S.LabelsWrapper $mt={mt}>
      <S.TrustItem>
        <ProtectionIcon />
        {t('confidential')}
      </S.TrustItem>
      <S.TrustItem>
        <PasswordIcon />
        {t('secure_ssl')}
      </S.TrustItem>
    </S.LabelsWrapper>
  );
};
